import { render, staticRenderFns } from "./MyForumThreads.vue?vue&type=template&id=ef329bca&"
import script from "./MyForumThreads.vue?vue&type=script&lang=js&"
export * from "./MyForumThreads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports